import React, { useCallback, useEffect, useMemo, useRef } from 'react';

import { PleaseWaitSpinner } from '../../../../jsxctl/utilctl';
import { Combo, ContentBox, SubContentBox } from '../../atoms';
import { PromoSelectorButtons } from '../promotions';
import { PromoProposalControl } from '../promotions/promo-proposal-control';
import { head } from 'lodash';
import { PriceChangeSuggestion, Section } from '../../../mvcapi/models/buyticket';
import { AddToCartRequestBase } from '../../../mvcapi/models/buyticket/ticketselection';
import { TicketQtySelector } from './ticket-qty-selector';
import { useAddTicketsToCartStore } from '../../../stores';
import { EMPTY_UUID } from '../../../logic';
import cIf from 'classnames';
import { ButtonsList } from '../../molecules';
import './advanced-ticket-selection.scss';
import { useAddPackageToCartStoreExt } from '../../../stores/add-to-cart-stores/add-package-to-cart-store-ext';
import { SelectedTicketInfo } from '../../../logic/models';
import { FindTicketsResult } from '../../../mvcapi/models/buyticket/findticketsresult';
import { FindPackageTicketsResult } from '../../../mvcapi/models/buypackage/find-package-tickets-result';

const tr = require('ts-translate-js').default.boundTR;

type AdvancedTicketSelectionProps = {
    //packageID?: number;
    //eventDateIDs?: number[];
    onPromoUpdated?: any;
    //productType: string;
    maxQty: number;
    //limitQtySales: number;
    //suggestedQtySales: number;
    //internetTicketQTYMultipleOf: number;
    //sections?: any[];
    //forceSectionInPromo: boolean;
    //packages?: any[];
    //seePromoLink?: string;
    //packageNumberForEventDate?: number;
    //preferredSelectedSectionId?: number;
    scheduleRange?: any;
    hideBestTicketSelection?: boolean;
    //autoFindTicket?: any;
    clearPreviousSelection?: boolean; // Used to clear the previous selection when the user search for new tickets
    onContentChange?: any;
    onBuyClick?: any;
    onFindTickets?: any;
    integ?: any;
    useNewSale?: boolean;
    addToCartRequest?: AddToCartRequestBase; // Optional. Used for price change suggestion.
    //HasVenuePlan: boolean;
    onGoBackToSeatPlan?: () => void;
    onPriceChangeSuggestions?: (priceChangeSuggestions: PriceChangeSuggestion[]) => void; // Optional. Used for price change suggestion.
} 

export function AdvancedTicketSelection(props: AdvancedTicketSelectionProps) {
    const [ preferredSelectedSectionId, selectedSection, setSelectedSection ] = useAddTicketsToCartStore(s => [ s.preferredSelectedSectionId, s.selectedSection, s.setSelectedSection ]);
    const [hasError, setHasError] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [showPromoSelector, setShowPromoSelector] = React.useState(false);
    const promoInfo = useAddTicketsToCartStore(s => s.eventDate?.PromoInfo);
    const hiddenPromo = useAddTicketsToCartStore(s => s.hiddenPromo);
    const [eventDate, selectedTicketsByEventDateId, eventDateSections ] = useAddTicketsToCartStore(s => [ s.eventDate, s.selectedTicketsByEventDateId, s.eventDate?.Sections ]);
    const [searchingTicket, setSearchingTicket, autoFindTicket ] = useAddTicketsToCartStore(s => [ s.searchingTicket, s.setSearchingTicket, s.autoFindTicket ]);

    const addNewTicketsForEvent = useAddTicketsToCartStore(s => s.addNewTickets);
    const addNewTicketsForPackage = useAddPackageToCartStoreExt(s => s.addNewTickets);
    const [ packageId, selectedEventDateIds, packageSections, getSelectedSectionNames ] = useAddPackageToCartStoreExt(s => [ s.packageId, s.selectedEventDateIds, s.package?.Sections, s.getSelectedSectionNames ] );
    const isPackageSale = useAddPackageToCartStoreExt(p => p.isAPackageSale);

    const sectionsList = isPackageSale() ? packageSections : eventDateSections;

    const [numberOfTicket, setNumberOfTicket] = React.useState(eventDate.SuggestedQtySales || eventDate.InternetTicketQTYMultipleOf || 1);

    const modalContainerRef = useRef(null);

    useEffect(() => {
        if(preferredSelectedSectionId != 0) {
            const preferredSelectedSection = sectionsList.find((section) => section.ID === preferredSelectedSectionId);
            if(preferredSelectedSection)
                setSelectedSection(preferredSelectedSection.ID);
        }
    }, []);

    useEffect(() => {

        updateSectionIDAndAutoFindTicketOnLoad();

        if(props.onContentChange !== undefined) props.onContentChange();
    });

    const getEventDateIds = useCallback((): number[] => {
        if(isPackageSale())
            return selectedEventDateIds;
        else
            return [eventDate.EventDateID];
    }, [isPackageSale, selectedEventDateIds, eventDate.EventDateID]);

    const getSelectedTickets = () => { 
        let selectedTickets = [] as SelectedTicketInfo[];
        if(isPackageSale())
            selectedEventDateIds.forEach(eventDateId => {
                if(selectedTicketsByEventDateId[eventDateId])
                    selectedTickets = [...selectedTickets, ...selectedTicketsByEventDateId[eventDateId].selectedTickets];
            });
        else if(selectedTicketsByEventDateId[eventDate.EventDateID])
                selectedTickets = selectedTicketsByEventDateId[eventDate.EventDateID].selectedTickets;
        return selectedTickets;
    };

    const afterFindTicketsSuccess = useCallback((result: FindTicketsResult | FindPackageTicketsResult) => {
        let hasError = false;
        let errorMsg = null;

        if (result.isSuccess)
            if(isPackageSale()) 
                addNewTicketsForPackage(result.foundTickets);
            else
                addNewTicketsForEvent(result.foundTickets);
        else
        {
            hasError = true;
            errorMsg = result.message;

            setSearchingTicket(false);
        }

        setHasError(hasError);
        setErrorMessage(errorMsg);
    }, [addNewTicketsForEvent, addNewTicketsForPackage, isPackageSale, setSearchingTicket]);

    // le id de section peut être zéro cherchera partout dans la salle (meilleure place)
    const findTickets = useCallback((newqty: number, sectionid: number) => {
        setSearchingTicket(true);

        const eventDateIds = getEventDateIds();
        if(props.scheduleRange != null) {
            tsapp.svc.BuyTicket.findTicketsByScheduleRange(tsapp.mvcapi, eventDate.EventDateID, newqty, props.scheduleRange, afterFindTicketsSuccess);
        }
        else if(!isPackageSale()) {
            tsapp.svc.BuyTicket.findTickets(tsapp.mvcapi, eventDateIds[0], newqty, afterFindTicketsSuccess, sectionid, "", props.clearPreviousSelection);
        }
        else
        {
            tsapp.svc.BuyTicket.findPackageTickets(tsapp.mvcapi, packageId, eventDateIds, newqty, afterFindTicketsSuccess, getSelectedSectionNames(), props.clearPreviousSelection);
        }
    }, [setSearchingTicket, getEventDateIds, props.scheduleRange, props.clearPreviousSelection, isPackageSale, eventDate.EventDateID, afterFindTicketsSuccess, packageId, getSelectedSectionNames]);

    const autoFindTicketOnChange = useCallback(async (qty: number, sectionid: number) => {
        await setSelectedSection(sectionid);
        findTickets(qty, sectionid);
    }, [findTickets, setSelectedSection]);

    const getSelectedSectionId = useCallback(() => {
        let sectionid = 0;

        if(selectedSection)
            sectionid = selectedSection.ID;
        
        if(autoFindTicket != null)
            sectionid = autoFindTicket.sectionid;

        if(sectionid == 0 && eventDate.ForceSectionInPromo && sectionsList.length > 0)
            sectionid = head<Section>(sectionsList).ID;


        if(sectionid != 0 && selectedSection == null) {
            setSelectedSection(sectionid);
        }

        return sectionid;
    }, [selectedSection, autoFindTicket, eventDate.ForceSectionInPromo, sectionsList, setSelectedSection]);

    const updateSectionIDAndAutoFindTicketOnLoad = useCallback(() => {
        let sectionid = getSelectedSectionId();
        
        if(sectionid != 0 && (selectedSection == null || (selectedSection && selectedSection.ID != sectionid)) && autoFindTicket != null) {
            autoFindTicketOnChange(autoFindTicket.qty, autoFindTicket.sectionid);
        }
    }, [getSelectedSectionId, selectedSection, autoFindTicket, autoFindTicketOnChange]);


    const handlePromoSelectorOnClose = useCallback(() => {
        setShowPromoSelector(false);
    }, [setShowPromoSelector]);

    const handleOnTicketQtyChange = useCallback((qty:number) => {
        setNumberOfTicket(qty);
    }, [setNumberOfTicket]);

    const handleChangeSection = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
        if(e.currentTarget && selectedSection?.ID !== parseInt(e.currentTarget.value)) {
            setSelectedSection(parseInt(e.currentTarget.value));
        }
    }, [setSelectedSection, selectedSection]);

    const handleOnButtonListClick = useCallback((sectionId: number) => {
        autoFindTicketOnChange(numberOfTicket, sectionId);
    }, [autoFindTicketOnChange, numberOfTicket]);

    const showSectionSelector = sectionsList && sectionsList.length > 0;
    const showSectionButtons = sectionsList && sectionsList.length >= 2 && sectionsList.length <= 5 && preferredSelectedSectionId === 0; // Between 2 and 5 sections, show buttons instead of a dropdown

    const qtySelectorCtrl = useMemo(() => {
        const sections = [];

        if(sectionsList?.length > 0) {
            sections.push({ id: 0, name: tr("Toute les sections") });
            sectionsList.forEach((item) => (sections.push({ id: item.ID, name: item.Name })));
        }

        return <table>
            <tr>
                <td className={cIf(['right top'],{'no-width': sections.length === 0 || showSectionButtons})}>{tr("Je veux")}</td>
                <td style={{width: "80px"}}>
                    <TicketQtySelector 
                        maxQty={10}
                        limitQtySales={eventDate.LimitQtySales}
                        suggestedQtySales={eventDate.SuggestedQtySales}
                        internetTicketQTYMultipleOf={eventDate.InternetTicketQTYMultipleOf}
                        defaultValue={numberOfTicket}
                        onQtyChange={handleOnTicketQtyChange}
                        onContentChange={props.onContentChange}>
                    </TicketQtySelector>
                </td>
                <td>{isPackageSale() ? tr("forfaits") : tr("billets")}</td>
            </tr>

            {(showSectionSelector && !showSectionButtons) && <tr>
                <td className='right top'>{tr("Dans quelle section")}</td>
                <td colSpan={2}>
                    <Combo className="form-control" 
                        items={sections}
                        valueField="id"
                        textField="name"
                        selectedValue={selectedSection?.ID || 0}
                        onChange={handleChangeSection} 
                    />
                </td>
            </tr>}

            {(showSectionSelector && showSectionButtons) && <tr>
                <td colSpan={3}>
                    <ButtonsList buttonInfos={sections.map((item) => {
                            return {
                                class: "btn-primary",
                                children: <div>{item.name}</div>,
                                onClick: () => handleOnButtonListClick(item.id)
                            };
                        })} 
                    />
                </td>
            </tr>}
        </table>;
    }, [sectionsList, showSectionButtons, eventDate.LimitQtySales, eventDate.SuggestedQtySales, eventDate.InternetTicketQTYMultipleOf, numberOfTicket, handleOnTicketQtyChange, props.onContentChange, isPackageSale, showSectionSelector, selectedSection?.ID, handleChangeSection, handleOnButtonListClick]);

    return <>
        <div ref={modalContainerRef}/>
        {showPromoSelector && <PromoSelectorButtons
            container={modalContainerRef}
            packages={eventDate.Packages} 
            onClose={handlePromoSelectorOnClose} 
        />}
        <div className="advanced-ticket-selection">
            {promoInfo && promoInfo.PromoID != EMPTY_UUID && getSelectedTickets().length === 0 && <ContentBox>
                <div className='promo-proposal'>
                    <PromoProposalControl 
                        promoInfo={promoInfo}
                        hiddenPromo={hiddenPromo}
                        showProposalMessage={false}
                        onPromoUpdated={props.onPromoUpdated}
                        onContentChange={props.onContentChange} 
                        addToCartRequest={props.addToCartRequest} 
                        onPriceChangeSuggestions={props.onPriceChangeSuggestions}
                        isAPackageSale={isPackageSale()}
                    />
                </div>
            </ContentBox>}
            <ContentBox>
                <div className='content-box-magnifier-image'>
                    <img alt="" width={95} src="/static/tsapp/latest/img/magnifier.svg" />
                </div>
                <SubContentBox> 
                    <div>
                        {qtySelectorCtrl}
                        {hasError && <div className="alert alert-danger">{errorMessage}</div>}
                    </div>
                    {!showSectionButtons && <div className='action'>
                        {searchingTicket ? <PleaseWaitSpinner/> 
                            :<button type="button" className="btn btn-primary text-uppercase btn-xs-mobile" onClick={() => findTickets(numberOfTicket, getSelectedSectionId())}>{tr("Chercher")}</button>
                        }
                    </div>}
                </SubContentBox>
            </ContentBox>
            {eventDate.HasVenuePlan &&
            <ContentBox>
                <div className='content-box-plan-image'>
                    <img alt="" width="100%" src="/static/tsapp/latest/img/venue-plan-icon.svg" />
                </div>
                <div className='action'>
                    <button type="button" className="btn btn-primary text-uppercase btn-xs-mobile" onClick={props.onGoBackToSeatPlan}>{tr("Choisir sur le plan")}</button>
                </div>
            </ContentBox>}
        </div>
    </>;
}